var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVr = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 35 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.378 17.779a2.125 2.125 0 0 1 2.125 1.874v.876h9.132a3.006 3.006 0 0 0 2.997-3V6.624a3.007 3.007 0 0 0-2.997-3.008H6.373a3.024 3.024 0 0 0-3.008 3.008v10.903a3.023 3.023 0 0 0 3.008 3h8.882v-.875a2.1 2.1 0 0 1 2.12-1.872l.003-.002ZM1.968 6.247c-.965 0-1.75 1.346-1.75 3v4.507c0 1.655.785 3 1.75 3V6.248Zm31.064 0v10.51c.966 0 1.75-1.348 1.75-3V9.25c0-1.655-.784-3-1.75-3v-.003ZM15.622.475c-1.658 0-3.007.786-3.007 1.751h10.51a1.25 1.25 0 0 0-.407-.88 3.776 3.776 0 0 0-2.593-.87h-4.502Zm8.256 14.905a3.752 3.752 0 0 1-2.646-6.409 3.751 3.751 0 0 1 1.921-1.026 3.754 3.754 0 1 1 .723 7.437l.002-.002Zm-12.756 0a3.754 3.754 0 0 1-2.654-6.407 3.749 3.749 0 0 1 4.09-.812 3.756 3.756 0 0 1 2.315 3.47 3.756 3.756 0 0 1-3.753 3.75l.002-.001Z"
  })));
};
export { SvgVr as ReactComponent };